export function AvatarCircle({ username }: { username: string }) {
	return (
		<div
			className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full
				border border-(--glass-border) bg-(--glass-highlight) text-xs font-bold
				text-(--text-primary)"
		>
			{(username || '?')[0].toUpperCase()}
		</div>
	);
}
